import { endpoints } from "@app/api/apis";
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { ThemedText, ThemedView } from '@app/theme';
import { Platform, TouchableOpacity } from "react-native";
import Edit from "../../../assets/Icons/Edit";
import { FetchPortfolioInitPayload, FetchPortfolioInitResponse, FetchPortfolioVerifyPayload } from "./type";

export const getRtaDetails = async (
    applicationId: string, 
    successCallback?: (data: any) => void, 
    errorCallback?: (error: any) => void
) => {
    const _applicationId = await getApplicationId(applicationId);
    console.log('_applicationId', _applicationId);
    try {
        const response = await axios.get(endpoints.getDefaultRTA + _applicationId);
        successCallback && successCallback(response.data);
        return response.data;
    } catch (error) {
        errorCallback && errorCallback(error);
        console.log('Error in getRtaDetails', error);
        return null;
    }
}

export const getFetchSDKData = async (
    applicationId: string, 
    panNumber: string,
    phoneNumber : string,
    successCallback?: (data: any) => void, 
    errorCallback?: (error: any) => void
) => {
    const _applicationId = await getApplicationId(applicationId);
    try {
        const body = {
            "applicationId": _applicationId,
            "panNumber": panNumber,
            "phoneNumber": phoneNumber,
            "redirectionUrl":
                Platform.OS === 'web'
                    ? window.location.search
                        ? window.location.origin + window.location.pathname + window.location.search + '&mfc_fetch_response=mfc&appId=' + _applicationId
                        : window.location.origin + '/?mfc_fetch_response=mfc&appId=' + _applicationId
                    //We just need this to read on onNavigationChanges
                    : "https://app.voltmoney.in/?mfc_fetch_response=mfc",
            "isRetryAllowed": false
        }
        const response = await axios.post(endpoints.getFetchSDK , body);
        successCallback && successCallback(response.data);
        return response.data;
    } catch (error) {
        errorCallback && errorCallback(error);
        console.log('Error in getFetchSDKData', error);
        return null;
    }
}



// get application id from async storage if not then return the application id passed
export const getApplicationId = async (applicationId: string) => {
    const _applicationId = await AsyncStorage.getItem('application_id');
    if (!_applicationId) {
        return applicationId;
    }
    return _applicationId;
}
export const setApplicationId = async (applicationId: string) => {
    const _applicationId = await AsyncStorage.setItem('application_id', applicationId);
    return _applicationId;
}

export const renderList = (listData: any[] , color = '#2D57D9') => {
        return listData.map((item, index) => (
            <>
                <ThemedView
                    key={`${item.title}-${index}`}
                    flexDirection='row'
                    justifyContent='space-between'
                    alignItems='center'
                >
                    <ThemedView flexDirection='row' alignItems='center' style={{ paddingRight: 16 }}>
                        <ThemedView
                            backgroundColor="bg-fill-emphasis-primary-1"
                            style={{ height: 40, width: 40, borderRadius: 100 }}
                            alignItems='center'
                            justifyContent='center'
                        >
                            {item.icon}
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flex={1}>
                        <ThemedText variant='b4r' color='text-secondary' fontWeight='400' style={{ marginBottom: 4 }}>{item.title}</ThemedText>
                        <ThemedText variant='b3m' color='text-primary' fontWeight='500'>{item.subTitle}</ThemedText>
                    </ThemedView>
                    {
                        item.isEditable && (
                            <TouchableOpacity hitSlop={{left:10 , right :10 , bottom:10 , top:10}} onPress={() => { item.handleEdit && item.handleEdit() }}>
                                <Edit color={color} size={14} />
                            </TouchableOpacity>
                        )
                    }
                </ThemedView>
                {!item.isLast && <ThemedView height={1} width={'100%'} backgroundColor='border-primary' marginVertical='md' />}
            </>
        ))
}

export const handleFetchPortfolioInit = ({
    payload,
    successCallback,
    errorCallback,
}: {
    payload: FetchPortfolioInitPayload,
    successCallback?: (data: FetchPortfolioInitResponse) => void,
    errorCallback?: (error: any) => void,
}) => {
    axios
    //@ts-expect-error
    .post(endpoints.fetchInit, payload, { handleFromMF: true })
    .then(res => {
        successCallback &&
        successCallback(res.data)
    })
    .catch(err => {
        errorCallback &&
        errorCallback(err)
    })
}

export const handleFetchPortfolioVerify = ({
    payload,
    successCallback,
    errorCallback,
}: {
    payload: FetchPortfolioVerifyPayload,
    successCallback?: (data: FetchPortfolioInitResponse) => void,
    errorCallback?: (error: any) => void,
}) => {
    axios
    //@ts-expect-error
    .post(endpoints.fetchVerify, payload, { handleFromMF: true })
    .then(res => {
        successCallback &&
        successCallback(res.data)
    })
    .catch(err => {
        errorCallback &&
        errorCallback(err)
    })
}


export const handleOtpReport = ({
    payload,
    successCallback,
    errorCallback,
}: {
    payload: any,
    successCallback?: (data: any) => void,
    errorCallback?: (error: any) => void,
}) => {
    axios
    //@ts-expect-error
    .post(endpoints.otpFeedback, payload, { handleFromMF: true })
    .then(res => {
        successCallback &&
        successCallback(res.data)
    })
    .catch(err => {
        errorCallback &&
        errorCallback(err)
    })
}

export const editableErroCode = (errorCode: string) => {
    switch (errorCode) {
        case 'INVALID_COMBINATION_FOR_MFC':
            return true;
        case 'NO_INVESTMENTS_CAMS':
            return true;
        case 'NO_INVESTMENTS_KFIN':
            return true;
        case 'INVALID_PAN':
            return true;    
        default:
            return false;
    }
}

export const markPanInputInvalid = (errorCode: string) => {
    if(errorCode === 'INVALID_PAN') {
        return true;
    }
    return false;
}